import { DateTime } from 'luxon'
import { DashboardEntry } from '../api/dashboard'
import { DateRange, isMathDateDange } from '../components/daterange-picker'
import { addDateMaths, dateMathToString, diffDateMaths, getDateMath } from '../datemath'

export const moveRange =
	(direction: 'plus' | 'minus') =>
	(range: DateRange | undefined): DateRange | undefined => {
		if (!range) return range
		if (isMathDateDange(range)) {
			const mathStart = getDateMath(range.start)
			const mathEnd = getDateMath(range.end)
			let diff
			if (direction === 'plus') {
				diff = diffDateMaths(mathStart, mathEnd)
			} else {
				diff = diffDateMaths(mathEnd, mathStart)
			}

			return {
				start: `now${dateMathToString(addDateMaths(mathStart, diff))}/${range.start.split('/').at(-1)}`,
				end: `now${dateMathToString(addDateMaths(mathEnd, diff))}/${range.start.split('/').at(-1)}`,
			}
		}

		const days = Math.round(range.end.diff(range.start, 'days').days)
		return {
			start: range.start[direction]({ days }).startOf('day'),
			end: range.end[direction]({ days }).endOf('day'),
		}
	}

export function getOffset(seconds: number, delta: number, containerWidth: number) {
	const offset = (seconds * delta) / containerWidth
	return Math.round(offset / 3600) * 3600
}

export function getDropTimes({
	entry,
	type,
	seconds,
	delta,
	containerWidth,
}: {
	delta: number
	entry: DashboardEntry
	seconds: number
	type: 'left' | 'right'
	containerWidth: number
}) {
	const offset = getOffset(seconds, delta, containerWidth)

	if (offset === 0) {
		return [entry.dateFrom, entry.dateTo]
	}

	const times: DateTime[] = []

	if (type === 'left') {
		times.push(entry.dateTo)
		times.push(entry.dateFrom.plus({ seconds: offset }))
	} else if (type === 'right') {
		times.push(entry.dateFrom)
		times.push(entry.dateTo.plus({ seconds: offset }))
	}

	times.sort((a, b) => a.valueOf() - b.valueOf())

	return times
}
